import { Response } from "../../types/Response.interface";
import { yupResolver } from "@hookform/resolvers/yup";
import { apiClient } from "../../utils/apiClient";
import { useForm } from "react-hook-form";
import * as yup from "yup";

export interface Inputs {
  email: string;
}

const schema = yup
  .object({
    email: yup.string().email().required(),
  })
  .required();

const useNext = (onNext: (email: string) => void) => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isDirty },
  } = useForm<Inputs>({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (result: Inputs) => {
    const res: Response = await apiClient.post("/api/v1/auth/verify", result);

    if (res.ok) {
      if (res.data.exists) {
        setError("email", {
          type: "custom",
          message: "email already exists.",
        });
      } else {
        // Auth Callback
        onNext(result.email);
      }
    }
  };

  return {
    register,
    handleSubmit,
    errors,
    isDirty,
    onSubmit,
  };
};

export default useNext;
